export default __webpack_public_path__ + "static/media/church_768.818db840.webp";